export default __webpack_public_path__ + "static/media/MadhaviLovelace.8923bf96.png";